/**
 * GroupsListTour — guided tour for the Compressor Groups list page.
 * Stages: "list" (default view) ↔ "modal" (quick-create modal open).
 */
import { useState } from "react";
import { useT } from "@/lib/i18n";
import ControlledSeqTour from "./ControlledSeqTour";

const STORAGE_KEY = "tour_seq_groups_v1";

function buildSteps(t) {
  return [
    {
      stage: "list",
      target: '[data-tour="groups-header"]',
      content: t("tour.sg.header",
        "Welcome to Compressor Groups. Each group is a set of compressors at one customer site that the sequencer balances around a shared pressure setpoint (Pset)."),
      placement: "bottom",
    },
    {
      stage: "list",
      target: '[data-testid="seq-groups-create-open"]',
      content: t("tour.sg.create",
        "New group creates an empty group from scratch — you give it a name, tenant and Pset, then attach compressors later from the group detail page."),
      placement: "bottom",
    },
    {
      stage: "modal",
      target: '[data-tour="groups-create-form"]',
      content: t("tour.sg.form",
        "Fill in: Group name (how it shows in lists), Tenant (the CustomerID that owns the site), the target Pset in bar, and the allowed pressure bandwidth in %. Click Create to save."),
      placement: "top",
    },
    {
      stage: "list",
      target: '[data-tour="groups-example-row"]',
      content: t("tour.sg.row",
        "Every group shows its tenant, Pset, bandwidth and state. Click anywhere on the row to open the group — members, rotation order, WiFi setup and commissioning all live there. (This row is just an example.)"),
      placement: "bottom",
    },
    {
      stage: "list",
      target: '[data-tour="groups-example-delete"]',
      content: t("tour.sg.delete",
        "The trash icon deletes a group after a confirmation. Deleting a group does not delete the compressors — they simply become available for a new group."),
      placement: "left",
    },
    {
      stage: "list",
      target: '[data-tour="groups-onboard-link"]',
      content: t("tour.sg.wizard",
        "Recommended for real onboarding: the Onboard wizard finds compressors by serial, provisions their devices in the Control Plane and creates the group in one guided flow."),
      placement: "bottom",
    },
  ];
}

export default function GroupsListTour({ runFlag, onStart, onStageChange, onStop }) {
  const t = useT();
  const [steps] = useState(() => buildSteps(t));
  return (
    <ControlledSeqTour
      steps={steps}
      storageKey={STORAGE_KEY}
      runFlag={runFlag}
      onStart={onStart}
      onStageChange={onStageChange}
      onStop={onStop}
    />
  );
}
